
/**
 * Formats a price with the provided currency
 */
export const formatPrice = (price: number, currency: string = 'EUR') => {
  if (!price && price !== 0) return '';
  
  const currencySymbol = getCurrencySymbol(currency);
  
  // For some currencies, the symbol comes after the amount
  if (currency === 'FCFA' || currency === 'GOURDE') {
    return `${price.toFixed(2)} ${currencySymbol}`;
  }
  
  // For most currencies, the symbol comes before
  return `${currencySymbol}${price.toFixed(2)}`;
};

// Alias for formatPrice for backward compatibility
export const formatCurrency = formatPrice;

/**
 * Gets the appropriate currency symbol
 */
export const getCurrencySymbol = (currencyCode: string = 'EUR') => {
  switch (currencyCode) {
    case "EUR": return "€";
    case "USD": return "$";
    case "HTG": return "G";
    case "DOP": return "RD$";
    case "GBP": return "£";
    case "CAD": return "CA$";
    case "CHF": return "Fr";
    case "AUD": return "A$";
    case "JPY": return "¥";
    case "CNY": return "¥";
    case "RUB": return "₽";
    case "BRL": return "R$";
    case "MXN": return "Mex$";
    case "INR": return "₹";
    case "MAD": return "DH";
    case "XAF": return "FCFA";
    case "XOF": return "CFA";
    case "NGN": return "₦";
    case "ZAR": return "R";
    case "KES": return "KSh";
    default: return currencyCode;
  }
};
